export const YELLOW = '#f4e57a';
export const PINK = '#f775c7';
export const GREEN = '#b4db47';
export const ORANGE = '#f29d33';

export const NOTE_SIZE = 250;

export const SLIDE_WIDTH = 1920 / 2;

export const SLIDE_CONTENT_HEIGHT = 1080 / 2;
export const SLIDE_NOTES_HEIGHT = 180;
export const SLIDE_HEIGHT = SLIDE_CONTENT_HEIGHT + SLIDE_NOTES_HEIGHT;

export const CANVAS_SCALE = SLIDE_WIDTH / NOTE_SIZE;

export const SUB_SECTION_HEIGHT = 250;
export const CANVAS_SUB_SECTION_WIDTH = 250;
export const SECTION_HEIGHT = 300;

export const SLIDE_SECTION_HEIGHT = SLIDE_HEIGHT + 100;
export const STORYBOARD_SUB_SECTION_WIDTH = SLIDE_WIDTH;

export const CANVAS_SECTION_MARGIN = 30;
export const STORYBOARD_SECTION_MARGIN = 150;
export const SUB_SECTION_MARGIN = (SECTION_HEIGHT - SUB_SECTION_HEIGHT) / 2;

export const CANVAS_TOP_MARGIN = 200;
export const STORYBOARD_TOP_MARGIN = 700;

export enum NoteColor { YELLOW = 'YELLOW', PINK = 'PINK', GREEN = 'GREEN', ORANGE = 'ORANGE' }

export const DEFAULT_COLOR = NoteColor.YELLOW;

export enum NoteType { T0 = 'T0', T1 = 'T1', T2 = 'T2', T3 = 'T3' }

export const DEFAULT_NOTE_TYPE = NoteType.T0;

export const EPSILON = 1e-6;

export const DEFAULT_FONT_SIZE = 32;

export const enum ProcessStep {
    BRAINSTORM = 'BRAINSTORM',
    BASIC_DATA = 'BASIC_DATA',
    STRUCTURE = 'STRUCTURE',
    SKETCH = 'SKETCH',
    EXPORT = 'EXPORT',
}

export const DEFAULT_PROCESS_STEP = ProcessStep.BRAINSTORM;

export const FULL_SCREEN_MARGIN = 0.02;

export const MIN_ZOOM_LEVEL = 1.0;



// WEBPACK FOOTER //
// ./src/constants/index.ts